import { Card, CardContent } from "@/components/ui/card";
import { Loader2, Brain, Utensils } from "lucide-react";

export function AIGenerationLoader() {
  return (
    <Card className="border-green-200 dark:border-green-800 bg-gradient-to-br from-green-50 to-teal-50 dark:from-green-950/20 dark:to-teal-950/20">
      <CardContent className="py-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="relative">
            <Utensils className="h-12 w-12 text-green-600 dark:text-green-400" />
            <Brain className="h-6 w-6 text-green-600 dark:text-green-400 absolute -top-1 -right-1 animate-pulse" />
          </div>
          <div className="text-center space-y-2">
            <div className="flex items-center justify-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin text-green-600 dark:text-green-400" />
              <h3 className="font-semibold text-lg">Gerando Plano Alimentar com IA</h3>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              Estamos analisando os dados do paciente e criando um plano personalizado com calorias calculadas...
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
